// Genere par tools/gen-icons.mjs. Ne pas editer a la main.
import { forwardRef } from 'react';
import type { IconProps } from './icon-props.js';
import { DEFAULT_SIZE } from './icon-props.js';

/**
 * Fabrique une icone "remix" (solid, fill currentColor, viewBox 24) a partir de
 * son inner SVG. Meme enveloppe que l'ancien createSolidIcon, mais l'interieur
 * (path/g multiples) est injecte tel quel, robuste a toute forme de la source.
 */
export function createRemixIcon(displayName: string, inner: string) {
  const html = { __html: inner };
  const Icon = forwardRef<SVGSVGElement, IconProps>(function Icon(
    { size = DEFAULT_SIZE, ...props },
    ref,
  ) {
    // size est en px de reference (maquette 1920) : rendu en rem pour suivre
    // l'echelle globale (tokens.css, regle racine).
    return (
      <svg
        ref={ref}
        width={`${size / 16}rem`}
        height={`${size / 16}rem`}
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        focusable="false"
        {...props}
        dangerouslySetInnerHTML={html}
      />
    );
  });
  Icon.displayName = displayName;
  return Icon;
}
